import React from "react";
import GraphicIconWrapper from "../UI/Graphic_IconWrapper";



export default function HudMenuBox({children, heading}) {

    if (!children || !Array.isArray(children) || children.length < 2) {
        return null; // or handle the case where there are not enough children
      }

  return (
  
      <div className="hud_item">
     
        {/* <h1>{heading}</h1> */}

        <div className="hud_item_columns">
          <div className="subHUDItem">
            {/* <h2>found {foundItems}</h2> */}
            {/* <GraphicIconWrapper txt={10} col={"lightgreen"} /> */}
            {children[0]}
          </div>
          <div className="subHUDItem">

            {children[1]}

            {/* {icon2()} */}
            {/* <GraphicIconWrapper txt={10} col={"darkgrey"} /> */}
            {/* <h2>left {itemsLeft}</h2> */}
          </div>
          </div>

      </div>

  );
}
